import React from 'react';

export const Plus: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="6 6 20 20" {...props}>
    <path
      d="M6.707 16.712A.711.711 0 016 15.995a.7.7 0 01.707-.707h8.575V6.717A.721.721 0 0116 6a.711.711 0 01.707.717v8.571h8.575a.711.711 0 01.717.707.72.72 0 01-.717.717h-8.575v8.571A.711.711 0 0116 26a.72.72 0 01-.717-.717v-8.571z"
      fill="currentColor"
    />
  </svg>
);
